import React from "react";
import PropTypes from "prop-types";
import { Alert } from "reactstrap";

const PortalSupportNotice = ({ variant = "inline", className = "" }) => {
  const text = (
    <>
      Having technical issues with the portal? Contact{" "}
      <a href="mailto:portalsupport@armadawebsolutions.com">portalsupport@armadawebsolutions.com</a>.
    </>
  );

  if (variant === "alert") {
    return (
      <Alert color="info" className={className} data-testid="portal-support-alert">
        {text}
      </Alert>
    );
  }

  return (
    <p className={`text-muted small mb-0 ${className}`} data-testid="portal-support-inline">
      {text}
    </p>
  );
};

PortalSupportNotice.propTypes = {
  variant: PropTypes.oneOf(["inline", "alert"]),
  className: PropTypes.string,
};

export default PortalSupportNotice;
